<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">{{maintenanceCalendarService.amenityInAmenityModal.amenityName}}</h4>
            </div>
            <div class="modal-body">
                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Name</label>
                    </div>
                    <div class="col-md-8">Fire Alarm Testing</div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Date</label>
                    </div>
                    <div class="col-md-8">28 june, 2019</div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Reminder</label>
                    </div>
                    <div class="col-md-8">1 Day Before</div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Notify</label>
                    </div>
                    <div class="col-md-8">Moshe Lokshin, Inna Lokshin</div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-4">
                        <label>Status</label>
                    </div>
                    <div class="col-md-8">Incomplete</div>
                </div>

                <div class="input-group-btn">
                    <button tabindex="-1" class="btn btn-primary submit" type="submit">Actions</button>
                    <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle" type="button"
                            aria-expanded="false"><span class="caret"></span></button>
                    <ul class="dropdown-menu" style="z-index: 1001;">
                        <li><a>Item 1</a></li>
                        <li><a>Item 2</a></li>
                    </ul>
                </div>

                <div class="detailed-view-navigation m-t-sm">
                    <div class="col-xs-6 col-md-6 no-padding">
                        <div class="button-section"
                             [ngClass]="{'active': activeTab === 'subtasks'}"
                             (click)="changeTab('subtasks');">
                            Subtasks
                        </div>
                    </div>
                    <div class="col-xs-6 col-md-6 no-padding">
                        <div class="button-section"
                             [ngClass]="{'active': activeTab === 'reminders'}"
                             (click)="changeTab('reminders');">
                            Reminders
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === 'subtasks'">
                    <div class="row m-t-md">
                        <div class="col-md-8">3 / 5 Completed</div>
                        <div class="col-md-4 text-right">
                            <i class="fa fa-trash pull-right clickable mtv-primary-color"></i>
                            <i class="fa icon-plus pull-right clickable mtv-primary-color"></i>
                        </div>
                    </div>
                    <mat-progress-bar class="m-t-md m-b-sm" mode="determinate" [value]="70"></mat-progress-bar>
                    <div class="task-item display-flex m-b-sm">
                        <i class="fa fa-circle-o mtv-primary-color m-r-sm" aria-hidden="true"></i>
                        <div>Task Name</div>
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </div>
                    <div class="task-item display-flex m-b-sm finished">
                        <i class="fa fa-check-circle mtv-primary-color m-r-sm" aria-hidden="true"></i>
                        <div>Task Name</div>
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </div>
                </div>
                <div *ngIf="activeTab === 'reminders'">Reminders</div>
            </div>
            <spinner [spinnerShow]="maintenanceCalendarService.spinnerShow ||
                        (maintenanceCalendarService.calendarSpinnerShow && maintenanceCalendarService.view == 'calendar')"></spinner>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-view/maintenance-calendar-view.component.html